'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dAbstract$002dCollection from "./java.util.-Abstract-Collection.js";
import * as $j_java$002eutil$002e$002dCollection from "./java.util.-Collection.js";
var $p;
/** @constructor */
function $c_ju_AbstractSet() {
}
export { $c_ju_AbstractSet as $c_ju_AbstractSet };
$p = $c_ju_AbstractSet.prototype = new $j_java$002eutil$002e$002dAbstract$002dCollection.$h_ju_AbstractCollection();
$p.constructor = $c_ju_AbstractSet;
/** @constructor */
function $h_ju_AbstractSet() {
}
export { $h_ju_AbstractSet as $h_ju_AbstractSet };
$h_ju_AbstractSet.prototype = $p;
$p.f = (function(that) {
  return ((that === this) || ($j_java$002eutil$002e$002dCollection.$is_ju_Collection(that) && ((that.T() === this.T()) && this.SX(that))));
});
$p.m = (function() {
  var _\uff3fself = this.cV();
  var result = 0;
  while (_\uff3fself.i()) {
    var t = result;
    var u = _\uff3fself.e();
    var t$1 = (t | 0);
    result = (($j_java$002elang$002e$002dObject.$dp_hashCode__I(u) + t$1) | 0);
  }
  return (result | 0);
});
